export var KeyType;
(function (KeyType) {
    KeyType["OWNER"] = "OWNER";
    KeyType["ACTIVE"] = "ACTIVE";
    KeyType["POSTING"] = "POSTING";
    KeyType["MEMO"] = "MEMO";
})(KeyType || (KeyType = {}));
export var PrivateKeyType;
(function (PrivateKeyType) {
    PrivateKeyType["AUTHORIZED_ACCOUNT"] = "AUTHORIZED_ACCOUNT";
    PrivateKeyType["PRIVATE_KEY"] = "PRIVATE_KEY";
    PrivateKeyType["MULTISIG"] = "MULTISIG";
})(PrivateKeyType || (PrivateKeyType = {}));
